import { useState } from "react";
import {
  Layout,
  Dropdown,
  Button,
  Badge,
  Avatar,
  Row,
  Col,
  Typography,
  Modal,
  Space,
} from "antd";
import LS_SERVICE from "../../utils/localStorage";
import { THEME } from "../../constants/constent";
import { LOGOUT } from "../../constants/api";
import { ERROR_MSG_TYPE } from "../../constants/messages";
import { displayMessage, makeFileURL, postAPI } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import { FullscreenOutlined } from "@ant-design/icons"; // Import the fullscreen icon

const { Title } = Typography;

function LayoutHeader() {
  const { Header } = Layout;
  const { theme } = LS_SERVICE.get("setting") || {};
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Fullscreen function
  const enterFullScreen = () => {
    const element = document.documentElement; // To make the entire document fullscreen
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      // For Firefox
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      // For Chrome, Safari and Opera
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      // For IE/Edge
      element.msRequestFullscreen();
    }
  };
  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // For Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      // For Chrome, Safari and Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // For IE/Edge
      document.msExitFullscreen();
    }
  };

  const toggleFullScreen = () => {
    if (document.fullscreenElement) {
      exitFullScreen(); // Exit fullscreen if already in fullscreen
    } else {
      enterFullScreen(); // Enter fullscreen
    }
  };

  const logout = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data["status"] === true) {
        LS_SERVICE.login_clear();
        window.location.reload();
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data["message"]);
      }
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Fail to Logout");
    };
    postAPI(LOGOUT, {}, successFn, errorFn);
  };

  const { company_name } = LS_SERVICE.get("setting") || {};
  const items = [
    {
      key: "0",
      label: (
        <Button
          style={{ width: "100%" }}
          loading={loading}
          disabled={loading}
          onClick={showModal}
        >
          Profile
        </Button>
      ),
    },
    {
      key: "1",
      label: (
        <Button
          style={{ width: "100%" }}
          disabled={loading}
          loading={loading}
          onClick={logout}
        >
          Logout
        </Button>
      ),
    },
  ];
  return (
    <>
      <Header theme="light">
        <Row gutter={[16, 16]} justify="space-between" align="middle">
          <Col span={23} style={{ textAlign: "center" }}>
            <Title level={5}>{company_name}</Title>
          </Col>
          <Col span={1}>
            <Space>
              <Avatar
                icon={<FullscreenOutlined />}
                style={{ cursor: "pointer", fontSize: "24px" }}
                onClick={toggleFullScreen}
                gap={1}
                shape="square"
              />
              <Dropdown menu={{ items }} placement="bottom">
                <Badge className="profile-square">
                  {LS_SERVICE.get("profile") !== "" ? (
                    <Avatar
                      src={makeFileURL(LS_SERVICE.get("profile"))}
                      size="large"
                      gap={1}
                      shape="square"
                    >
                      {LS_SERVICE.get("name").charAt(0).toUpperCase()}
                    </Avatar>
                  ) : (
                    <Avatar
                      style={{
                        backgroundColor: `#${theme || THEME}`,
                        verticalAlign: "middle",
                      }}
                      size="large"
                      gap={1}
                      shape="square"
                    >
                      {LS_SERVICE.get("name").charAt(0).toUpperCase()}
                    </Avatar>
                  )}
                </Badge>
              </Dropdown>
            </Space>
          </Col>
        </Row>
      </Header>

      <Modal
        title="User Profile"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
        width={400}
        bodyStyle={{
          padding: "30px",
          textAlign: "center",
        }}
        className="profile-modal"
      >
        <div style={{ marginBottom: "20px" }}>
          <Avatar
            shape="circle"
            size={100}
            src={makeFileURL(LS_SERVICE.get("profile"))}
            style={{
              border: `4px solid #${theme || THEME}`,
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          />
        </div>
        <div style={{ marginBottom: "20px" }}>
          <h3
            style={{
              fontSize: "24px",
              color: "#333",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            {LS_SERVICE.get("name") +
              " (" +
              LS_SERVICE.get("user_type").toUpperCase() +
              ")"}
          </h3>
          <p style={{ fontSize: "16px", color: "#777", marginBottom: "5px" }}>
            <strong>Email:</strong> {LS_SERVICE.get("email")}
          </p>
          <p style={{ fontSize: "16px", color: "#777" }}>
            <strong>Mobile:</strong> {LS_SERVICE.get("phone")}
          </p>
        </div>
        <div>
          <Button
            type="primary"
            onClick={() => {
              navigate("/profile/update");
            }}
            style={{
              width: "100%",
              color: "white",
              fontWeight: "bold",
            }}
          >
            Edit
          </Button>
        </div>
      </Modal>
    </>
  );
}
export default LayoutHeader;
